export enum NotMatchingFnsFieldTypesEnum {
  ORGANIZATION_NAME = 'ORGANIZATION_NAME',
  OBJECT_LEGAL_ADDRESS = 'OBJECT_LEGAL_ADDRESS',
}
